import Vue from 'vue';
import { ED_MODAL_EVENTS } from '@/plugins/ed-modal/ed-modal.plugin';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { ClassesService } from '@/classes/services/classes.service';

@Component({
  name: 'ed-delete-staff',
})
export default class EdDeleteStaffComponent extends Vue {

  @Prop({}) readonly params: any;
  
  public classes : any[]
  public subjects : any[];
  public templates : any[];
  public loadingData: boolean = false;
  public hasDetails: boolean = false;
  public seeSubjects: boolean = false;
  public seeClasses: boolean = false;
  public seeTemplates: boolean = false;
  public hasClasses: boolean = false;
  public hasSubjects: boolean = false;
  public hasTemplates: boolean = false; 

  get getUserMessage() {
    let msg = `${this.$t('tools.staff.confirmRemoveUser', { userName: this.params.userName })}`
    if( this.params.isTeacher && this.hasDetails) {
      msg += ` ${this.$t('tools.staff.confirmRemoveUserTeacher')}`;
    }
    return msg;
  }

  get isTeacher(){  
    return this.params.isTeacher;
  }

  get disableDelete() {
    return this.params.isTeacher && this.loadingData
  }

  goToCloseModal() {
      this.$EdModal.closeModal()
  }

  doDelete(){
    if(this.params.action) {
      setTimeout(() => { this.params.action(); }, 0);
    } 
    this.$EdModal.closeModal();
  }

  seeDetails(){
    if(this.classes?.length > 0) {
      this.seeClasses = true;
      this.seeSubjects = false;
      this.seeTemplates = false;
    } else if(this.subjects?.length > 0) {
      this.seeSubjects = true;
      this.seeClasses = false;
      this.seeTemplates = false;
    } else if(this.templates?.length > 0) {
      this.seeTemplates = true;
      this.seeClasses = false;
      this.seeSubjects = false;
    }
  }

  async loadAsignedClasses() {
    let data = await ClassesService.getTeachingClassesAndSharedContents(this.params.personId, this.params.orgId);
    this.loadingData = false;
    if(data.classes?.length > 0 || data.subjects?.length > 0 || data.templates?.length > 0) {
      this.classes = data.classes;
      this.subjects = data.subjects;
      this.templates = data.templates;
      this.hasSubjects = data.subjects?.length > 0;
      this.hasClasses = data.classes?.length > 0;
      this.hasTemplates = data.templates?.length > 0;
      this.hasDetails = this.hasSubjects || this.hasClasses || this.hasTemplates;
      this.seeDetails()
    }
  }

  getTeacherTypeName(type) {
    switch(type){
      case 'TEACHER':
        return this.$t('classes.headers.mainTeacher')
      case 'CO_INSTRUCTOR':
        return this.$t('classes.teachers.coTeacher')
      case 'COURSE_TEACHER':
        return this.$t('classes.teachers.courseTeacher')
      case 'SUBSTITUTE_TEACHER':
        return this.$t('classes.teachers.substituteTeacher')
      default:
        return null
    }
  }

  showClasses() {
    this.seeClasses = true;
    this.seeSubjects = false;
    this.seeTemplates = false;
  }

  showSubjects() {
    this.seeSubjects = true;
    this.seeClasses = false;
    this.seeTemplates = false;
  }

  showTemplates() {
    this.seeTemplates = true;
    this.seeClasses = false;
    this.seeSubjects = false;

  }
  mounted() {
    if(this.params.isTeacher) {
      this.loadingData = true;
      this.loadAsignedClasses()
    } else {
      this.hasDetails = false;
      this.loadingData = false;
    }
    
  }

}
